import { toast } from "react-toastify"
import Content from "../../../components/Content"
import WalletInterface from "../../../interfaces/Wallet.interface"
import { getPlayerWallet, getTeamWallet } from "../../../services/wallet.services"
import { useAppSelector } from "../../../store/store"
import { useEffect, useState } from "react"
import Loader from "../../../components/Loader"
import SendCredits from "./SendCredits"
import transferTypes from "../../../mapper/transfer-types"

const WalletPage = () => {
    const player = useAppSelector(state => state.player)
    const team = useAppSelector(state => state.team)
    const token = useAppSelector(state => state.token)
    const [wallet, setWallet] = useState<WalletInterface | null>(null)
    const [loading, setLoading] = useState(true)
    const [type, setType] = useState("RECEIVED")

    useEffect(() => {
        console.log(team.id)
        getTeamWallet(token || "", team?.id as string)
            .then((res) => {
                setWallet(res.data.payload.wallet)
            })
            .catch((error) => toast.error(error.response.data.message))
            .finally(() => setLoading(false))
    }, [])

    if (loading) return (
        <Content className="flex items-center justify-center">
            <Loader />
        </Content>
    )

    if (!loading && !wallet) return (
        <Content className="flex items-center justify-center">
            <p className="text-zinc-700 uppercase text-sm">Que raro... Al parecer no tenes billetera.</p>
        </Content>
    )

    return (
        <Content className="flex flex-col">
            <div className="grid grid-cols-1 gap-5 md:grid-cols-6 md:gap-10">
                <div className="md:col-span-2 flex flex-col gap-5 p-5 border rounded">
                    <p className="text-zinc-500 text-sm">Créditos disponible</p>
                    <p className="text-zinc-500 font-bold">${wallet?.amount?.toFixed(2)}</p>
                    <hr />
                    <SendCredits />
                </div>

                <div className="md:col-span-4 flex flex-col gap-5 border rounded p-5">
                    <div className="flex gap-2 items-center">
                        <p className="text-zinc-500 text-sm">Transferencias</p>
                        <select className="text-zinc-500 text-sm" onChange={(event) => setType(event.target.value)}>
                            <option value="RECEIVED">Recibidas</option>
                            <option value="SENT">Enviadas</option>
                        </select>
                    </div>

                    {type === "RECEIVED" &&
                        <>
                            {Number(wallet?.received_transfers.length) > 0 ?
                                wallet?.received_transfers.map(transfer => (
                                    <div key={transfer.id} className="flex flex-col gap-2">
                                        <div className="flex items-center justify-between">
                                            <div className="flex flex-col">
                                                <p className="text-lg text-zinc-700">
                                                    {transfer.from_wallet ?
                                                        <>
                                                            {transfer.from_wallet.player && transfer.from_wallet.player.name}
                                                            {transfer.from_wallet.team && transfer.from_wallet.team.name}
                                                            {!transfer.from_wallet.player && !transfer.from_wallet.team && "HaxStats"}
                                                        </>
                                                        :
                                                        "HaxStats"
                                                    }
                                                </p>
                                                <p className="text-sm text-zinc-700">{transferTypes[transfer.type]}</p>
                                                {transfer.description && <p className="text-zinc-500 text-sm">{transfer?.description}</p>}
                                            </div>
                                            <p className="text-green-400 text-sm">+ CT${transfer?.amount?.toFixed(2)}</p>
                                        </div>
                                    </div>
                                ))
                                :
                                <p className="text-zinc-700 text-sm uppercase">No tenes transferencias recibidas.</p>
                            }
                        </>
                    }

                    {type === "SENT" &&
                        <>
                            {Number(wallet?.sent_transfers.length) > 0 ?
                                wallet?.sent_transfers.map(transfer => (
                                    <div key={transfer.id} className="flex flex-col gap-2">
                                        <div className="flex items-center justify-between">
                                            <div className="flex flex-col">
                                                <p className="text-lg text-zinc-700">
                                                    {transfer.to_wallet ?
                                                        <>
                                                            {transfer.to_wallet.player && transfer.to_wallet.player.name}
                                                            {transfer.to_wallet.team && transfer.to_wallet.team.name}
                                                            {!transfer.to_wallet.player && !transfer.to_wallet.team && "HaxStats"}
                                                        </>
                                                        :
                                                        "HaxStats"
                                                    }
                                                </p>
                                                <p className="text-sm text-zinc-700">{transferTypes[transfer.type]}</p>
                                                {transfer.description && <p className="text-zinc-500 text-sm">{transfer?.description}</p>}
                                            </div>
                                            <p className="text-zinc-500 text-sm">- CT${transfer?.amount?.toFixed(2)}</p>
                                        </div>
                                    </div>
                                ))
                                : <p className="text-zinc-700 text-sm uppercase">No tenes transferencias enviadas.</p>
                            }
                        </>
                    }
                </div>
            </div>
        </Content>
    )
}

export default WalletPage